import axiosInstance from "../instance/axiosInstance";

class SettingsAPI {
  static async getEstablishmentInfo() {
    try {
      const response = await axiosInstance.get("/settings/establishment-info");
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async getCountriesList() {
    try {
      const response = await axiosInstance.get("/settings/countries-list");
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async getCitiesList(id, page = 1, query) {
    let url = `/settings/country/${id}/cities?page=${page}`;

    if (query) {
      url += `&search_name=${encodeURIComponent(query)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async updateEstablishment(data) {
    try {
      const response = await axiosInstance.post(
        "/settings/update-establishment",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
}
export default SettingsAPI;
